// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"198":"c5e1511e","498":"1e0a12d1","703":"4bc8a967","787":"c4e7bb7a"}[chunkId] + ".chunk.js";
};